import React from 'react'
import { Warning } from '@material-ui/icons'

const UncompatibleNavigator = () => {
  return (
    <div className='uncompatible-navigator-alert'>
      <Warning className='mb-1' />
      <span className='font-weight-bold py-1'>Browser Incompatível!</span>
      <span className='py-1'>Clique no link para baixar o navegador recomendado.</span>
      <a
        className='py-1'
        style={{ textDecoration: 'underline' }}
        href='https://www.google.com/intl/pt-BR/chrome/'
      >
        Instalar navegador recomendado
      </a>
    </div>
  )
}

export default UncompatibleNavigator
